module.exports = __webpack_public_path__ + "static/media/user.02a946bc.svg";